<template>
  <v-app :id="showLogo ? 'loginBendizer' : 'login'" :class="customColor" tabindex="0"
  @keydown.enter="login">
    <v-content >
      <v-container fluid fill-height class="login-container">
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md6 lg4>
            <v-card class="elevation-12 pa-2 login-card"  :class="customColor">
              <v-overlay :value="overlay" opacity="0.8">
                <v-progress-circular
                  indeterminate
                  size="64"
                  color="primary"
                ></v-progress-circular>
                <div class="mt-4 white--text">Autenticando...</div>
              </v-overlay>
              
              <v-card-text class="text-center">
                <div class="layout column align-center">
                  <img 
                    v-if="showLogo" 
                    :src="'img/'+logoImage" 
                    class="login-logo"
                    alt="Logo"
                  />
                  <h1 v-if="!isTec" class="login-title mb-2" :class="cor">ELTSYS - SAÚDE</h1>
                  <span class="login-subtitle" :class="cor">
                    <strong>{{software}}</strong>
                  </span>
                </div>
                
                <v-form ref="form" v-model="formValid" lazy-validation>
                  <v-text-field
                    v-model="user.username"
                    label="Email"
                    prepend-inner-icon="mdi-account"
                    outlined
                    rounded
                    clearable
                    @keydown.enter="login"
                    :rules="usernameRule"
                    :error="error"
                    class="mb-2"
                  />
                  
                  <v-text-field
                    v-model="user.password"
                    :type="hidePassword ? 'password' : 'text'"
                    label="Senha"
                    prepend-inner-icon="mdi-lock"
                    :append-icon="hidePassword ? 'mdi-eye-off' : 'mdi-eye'"
                    outlined
                    rounded
                    @keydown.enter="login"
                    :error="error"
                    @click:append="hidePassword = !hidePassword"
                  />
                </v-form>
              </v-card-text>
              
              <div class="text-right mb-4">
                <v-btn 
                  text 
                  small 
                  color="primary" 
                  @click="$router.push('recupararSenha')"
                  class="forgot-password"
                >
                  Esqueceu a senha?
                </v-btn>
              </div>
              
              <v-card-actions class="px-0">
                <v-btn 
                  block 
                  large
                  :color="isEFTSL ? 'primary' : '#006699'"
                  :disabled="!formValid" 
                  @click="login"
                  class="login-button"
                  depressed
                  rounded
                >  
                 Entrar               
                </v-btn>
              </v-card-actions>
              
              <div class="text-center mt-6 copyright">
                <span class="caption grey--text">Copyright © 2025</span>
                <v-icon small color="grey" class="mx-1">mdi-circle-small</v-icon>
                <span class="caption font-weight-bold grey--text">Softline, Angola</span>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      
      <GlobalSnackbar ref="snackbar"/>
    </v-content>
  </v-app>
</template>

<script>
import axios from '../../plugins/axios'
import { v4 as uuidv4 } from 'uuid'
const ls = require('local-storage')
const utilitarios = require('../../plugins/utilitarios')
export default {
  
  props: {
    source: String
  },
  data: () => ({

    customColor: '#424242',
    isEFTSL: true,
    cor: '',
    isIlhadaVerdade: true,
    software: '',
    formValid: true,
    conectionStatus: '',
    progresso: false,
    browser: '',
    overlay: false,
    showLogo: false,
    counter_: 0,
    hidePassword: true,
    error: false,
    logoImage:'logoKalawenda.png',
    showResult: false,
    color: 'red',
    result: '',
    usernameRule: [
      // this.value.replace(/[^\d]/, ''),

      v => !!v || 'campo obrigatório.',
      v => {
        const pattern = /^[A-Za-z0-9 .,\-_:!?@#]+$/
        return pattern.test(v) || 'Inválido.'
      }
    ],
    drawer: null,
    user: {
      username: '',
      password: ''
    },
    long: '',
    lat: ''
  }),

  computed: {
    loggedUser () {
      const user = this.$store.getters.loggedUser
      return user // this.$session.get("role")// this.$session.getAll()// this.$session.flash.get("role")
    },

    isTec (){
       return window.location.host.includes('tec')
    },  

    falal () {
      return ls.get('fatal')
    }

  },

  created () {
    this.CheckConection()
    ls.set('mensagensDefault', [])
    window.addEventListener('keydown', this.handleKeydown);
    this.browser = this.$browserDetect.meta.name
    if (window.location.host.includes('IlhadaVERdade')) {
      ls.set('base', 'http://localhost:3000/api')
      
      this.isEFTSL = true
      this.software = 'MAIANGA'// Nome da Instituição reponsável
      this.cor = 'flex my-4 primary--text'// Cor das letras de login
      this.customColor = 'corMaianga' // Cor do BackEnd  
      ls.set('customColor', 'corMaianga')// Cor do componente Bar do software
   
    } else if (window.location.host.includes('eftskw') || window.location.host.includes('localhost')) { //************************ PARA O KALAWENDA */
      // ls.set('base', 'http://restrito.eftsk.com/api')
       ls.set('urlFoto','https://eftskw.softlineangola.net/')
       this.isEFTSL = false
       this.software = 'ITSK'// Nome da Instituição reponsável
     
       this.logoImage = 'logoKalawenda.png'
       this.showLogo = true


      ls.set('base', 'http://restrito.softlineangola.com:3000/api')       
      ls.set('urlFoto','https://eftsl.softlineangola.com/')
 

    }else if (window.location.host.includes('tec')) { //************************ PARA O KALAWENDA */
      // ls.set('base', 'http://restrito.eftsk.com/api')
       ls.set('urlFoto','https://tec-restrito.gereonline.com/')
       this.isEFTSL = false
       this.software = 'ITPET'// Nome da Instituição reponsável
     
       this.logoImage = 'logo_itpet.jpeg'
       this.showLogo = true


      ls.set('base', 'https://tec-restrito.gereonline.com/api')       
      ls.set('urlFoto','https://eftsl.softlineangola.com/')
 

    }
    
    else if (window.location.host.includes('eftsl') ) {
      ls.set('base', 'http://restrito.softlineangola.com:3000/api')
      this.isEFTSL = true
      this.software = 'MAIANGA'// Nome da Instituição reponsável
      this.cor = 'flex my-4 primary--text'// Cor das letras de login
      this.customColor = 'corMaianga' // Cor do BackEnd Login
      ls.set('customColor', 'corMaianga')// Cor do componente Bar do software
      ls.set('urlFoto','https://eftsl.softlineangola.com/')
      this.logoImage = ''
    } else if(window.location.host.includes('192.168.1.9')) {
       this.software = 'Server Local de Teste'
        ls.set('base', 'http://192.168.1.9:3000/api')
        
        this.isEFTSL = true
        this.software = 'Server Local'// Nome da Instituição reponsável
        this.cor = 'flex my-4 primary--text'// Cor das letras de login
        this.customColor = 'corMaianga' // Cor do BackEnd Login
        ls.set('customColor', 'corMaianga')// Cor do componente Bar do software
         this.logoImage = ''
    }else if(window.location.host.includes('192.168.18.16')){ /// configuração do esca
        ls.set('base', 'http://restrito.softlineangola.com:3000/api')
        ls.set('urlReport', `http://eftsl.softlineangola.com:8082/`)
        this.isEFTSL = false
        this.software = 'ITPS. Ilha da Verdade'// Nome da Instituição reponsável
        this.cor = 'flex my-4  #006699--text'// Cor das letras de login
        this.customColor = 'corMaianga' // Cor do BackEnd Login
        this.showLogo = true
        ls.set('customColor', 'corMaianga')
         this.logoImage = 'ilhaverdade.jpg'
    }else if(window.location.host.includes('192.168.18.15')  ){ /// configuração do esca
        ls.set('base', 'http://restrito.softlineangola.com:3000/api')
        ls.set('urlReport', `http://eftsl.softlineangola.com:8082/`)
        this.isEFTSL = false
        this.software = 'COMPLEXO ESCOLAR PRIVADO - ILHA DA VERDADE'// Nome da Instituição reponsável
        this.cor = 'flex my-4  #006699--text'// Cor das letras de login
        this.customColor = 'corMaianga' // Cor do BackEnd Login
        this.showLogo = true
         this.logoImage = 'ilhaverdade.jpg'
        ls.set('customColor', 'corMaianga')
        
    
    }else if(window.location.host.includes('192.168.1.220')  ){ /// configuração do esca
        ls.set('base', 'http://restrito.softlineangola.com:3000/api')
        ls.set('urlReport', `http://eftsl.softlineangola.com:8082/`)
        this.isEFTSL = false
        this.software = 'Escola de Saúde ALPEGA'// Nome da Instituição reponsável
        this.cor = 'flex my-4  #006699--text'// Cor das letras de login
        this.customColor = 'corMaianga' // Cor do BackEnd Login
        this.showLogo = true
         this.logoImage = 'logoAlpega.png'
        ls.set('customColor', 'corMaianga')
        
    }
    else if(window.location.host.includes('ee')){
       ls.set('base', 'http://restrito.softlineangola.com:3000/api')
      
      this.isEFTSL = true
      this.software = 'MAIANGA'// Nome da Instituição reponsável
      this.cor = 'flex my-4 primary--text'// Cor das letras de login
      this.customColor = 'corMaianga' // Cor do BackEnd Login
      ls.set('customColor', 'corMaianga')// Cor do componente Bar do software
    }
    else if(window.location.host.includes('192.168.1.254')){
       ls.set('base', 'http://restrito.softlineangola.com:3000/api')
      ls.set('urlReport', `http://192.168.1.254:8085/`)
      this.isEFTSL = fasle
      this.software = 'Escola de Saúde Castelo'// Nome da Instituição reponsável
      this.cor = 'flex my-4 primary--text'// Cor das letras de login
      this.customColor = 'corMaianga' // Cor do BackEnd Login
      ls.set('customColor', 'corMaianga')// Cor do componente Bar do software
    }else if (window.location.host.includes('192.168.0.254') ) {
      ls.set('base', 'http://192.168.0.254:3000/api')
      this.isEFTSL = true
      this.software = 'MAIANGA'// Nome da Instituição reponsável
      this.cor = 'flex my-4 primary--text'// Cor das letras de login
      this.customColor = 'corMaianga' // Cor do BackEnd Login
      ls.set('customColor', 'corMaianga')// Cor do componente Bar do software
      ls.set('urlFoto','http://192.168.0.254/')
      this.logoImage = ''
    }
    else{
        this.software = ''
    }
  },

   beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydown);
  },

 
  methods: {
    handleKeydown(event) {
      if (event.key === 'Enter' && this.formValid) {
        this.login();
      }
    },

    CheckConection () {
      if (!navigator.onLine) { this.conectionStatus = 'Verifique a sua conexão de internet' }
    },

    async login () {
      

      // const pattern = /([^A-Za-z0-9])$/
    if(this.$refs.form.validate()){
      this.overlay = true
      if (!this.user.username.includes("'") && !this.user.username.includes('"') && !this.user.username.includes('-')) {
        const userCredencial =
        {
          username: this.user.username,
          password: this.user.password
        }

        try {
          let isError = true
       
          const usuario = await axios.post('/login', userCredencial).then(res => res.data)
          isError = false
          
          this.CarregActividades()
          this.overlay = false

            // Validando se a licença está expirada
            if (usuario.dataActual > usuario.dataExpiracao) {
              ls.set('licencaExpirada', 1)
            } else {
              ls.set('licencaExpirada', 0)
            }

           
          const loggedUser = {
            'token': usuario.token,
            'idPessoa': usuario.idPessoa,
            'role': usuario.role,
            'username': usuario.username,
            'instituicao': usuario.instituicao,
            'sigla': usuario.sigla,
            'instituicaodescricao': usuario.instituicaodescricao,
            'anolectivo': usuario.anolectivo,
            'idanolectivo': usuario.idanolectivo,
            'nomeUsuario': usuario.nomeUsuario,
            'uuid': uuidv4(),
            'actividades': this.$store.state.actividades,
            'mudarPassword': usuario.mudarPassword,
            'token_Master': usuario.token_Master,
            'dataExpiracao': usuario.dataExpiracao,
            'foto': usuario.foto,
            'novadescricao': usuario.novadescricao,
            'usuarios_permitidos': usuario.usuarios_permitidos,
            'telefone': usuario.telefone,
            'pkUsuario': usuario.pkUsuario,
            'logged_date_control':usuario.logged_date_control,
            'nivel_user': usuario.nivel_user,
            'publicity': usuario.publicity,
            'dataUser': utilitarios.ObterDataActual(), // Guarda a data de login para ser usado no momento de actualizar o status,
            'idLoginLogs': usuario.idLoginLogs,
            'isintegrado': usuario.isintegrado,
            'dataExpiracao': usuario.dataExpiracao,
            'dataActual': usuario.dataActual,
            'ims': usuario.ims

          // Guarda o uniqueuserid do usuário logado
          }
 

              this.$store.dispatch('loggedUser', loggedUser) // mando para a store.js
              this.$store.dispatch('textMessage', { 'msg': 'Parabens, você logou  com sucesso !', 'classMessage': 'msgSucess', 'timeout': 3000 })
              if(loggedUser.role === 'ROLE_GP')
                this.$router.push('/desempenho/menu')
              else
                this.$router.push('welcome')

        //  }
 
        } catch (error) {
          console.error('Erro ao fazer login:', error);

            if( error.response.status === 403 ){
              this.$refs.snackbar.mostrar("A sua conta encontra-se inativa , por favor contacte o seu pedagógico!", "error", "top");
            }else if( error.response.status === 404 ){
              this.$refs.snackbar.mostrar("Email ou Palavra-passe incorrecta!", "error", "top");
            }else if( error.response.status === 402 ){
              this.$refs.snackbar.mostrar("Sua conta está inativa. Para reativar, atualize clicando em 'Esqueceu a senha?", "warning", "top");
              this.color = "orange"
            }
            else{
               
              this.$refs.snackbar.mostrar("Impossível entrar no sistema, por favor contacte o suporte!", "error");
            }
          this.showResult = true

          this.$store.dispatch('textMessage', { 'msg': 'Usuärio ou senha incorrecta !', 'classMessage': 'msgError', 'timeout': 3000 })
        } finally {
          this.overlay = false
        }
      } else {
        this.$store.dispatch('usuario', { 'msg': 'Inválido !', 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }
    },
    async CarregActividades () {
      try {
        this.$store.state.actividades = await axios
          .get('/listAberturaFechoInstituicao')
          .then(res => res.data)
        // console.log( this.$store.state.actividades);
      } catch (error) {

      }
    },

    async  GetUserLocation (usuario) {
     
    },
    async LoginlogsInsert (longitude, latitude) {
      let dtt = await this.ObterDataTimeRemote()
      const params =
      {
        loginUpdate: 0,
        username: ls.get('idPessoa'),
        nome: ls.get('nomeUsuario'),
        datain: dtt,
        dataout: '',
        autor: ls.get('nomeUsuario'),
        loginpkCode: ls.get('uuid'),
        instituicao: ls.get('instituicaodescricao'),
        role: ls.get('role'),
        latitude: 'latitude',
        longitude: 'longitude'

      }

      // consumindo a API
      try {
        let msg = await axios
          .post('/InsertOrUpdateLoginLogs', params)
          .then(res => res.data)
      } catch (error) {

      }
    },
    ObterDataTimeRemote () {
      var today = new Date()
      var day = today.getDate() + ''
      var month = (today.getMonth() + 1) + ''
      var year = today.getFullYear() + ''
      var hour = today.getHours() + ''
      var minutes = today.getMinutes() + ''
      var seconds = today.getSeconds() + ''

      day = checkZero(day)
      month = checkZero(month)
      year = checkZero(year)
      hour = checkZero(hour)
      minutes = checkZero(minutes)
      seconds = checkZero(seconds)

      return (year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds)

      function checkZero (data) {
        if (data.length === 1) {
          data = '0' + data
        }
        return data
      }
    }

  }

}
</script>
<style scoped lang="scss">
.login-container {
  background-size: cover;
  background-position: center;
  
}
#login {
  background: linear-gradient(135deg, #424242 0%, #212121 100%);
  background-image: url('https://cdn.vuetifyjs.com/images/parallax/material.jpg');
  background-blend-mode: overlay;
}

#loginBendizer {
  background: linear-gradient(135deg, rgba(66,66,66,0.9) 0%, rgba(33,33,33,0.9) 100%);
  background-image: url('/img/bg20.jpg');
  background-blend-mode: overlay;
}

.login-card {
  border-radius: 16px !important;
  backdrop-filter: blur(5px);
  background-color: rgba(255, 255, 255, 0.9) !important;
  
  .corKilamba {
    background-color: rgba(0, 102, 153, 0.1);
    border: 1px solid rgba(0, 102, 153, 0.2);
  }
  
  .corMaianga {
    background-color: rgba(25, 118, 210, 0.1);
    border: 1px solid rgba(25, 118, 210, 0.2);
  }
}

.login-logo {
  max-width: 120px;
  height: auto;
  filter: drop-shadow(0 2px 4px rgba(0,0,0,0.1));
}

.login-title {
  font-size: 1.8rem;
  font-weight: 700;
  letter-spacing: -0.5px;
  background: linear-gradient(to right, #006699, #0099cc);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.login-subtitle {
  font-size: 1rem;
  opacity: 0.8;
}

.forgot-password {
  font-size: 0.75rem;
  text-transform: none;
  letter-spacing: 0;
}

.login-button {
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  height: 48px !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
  color: #fff;
}

.copyright {
  opacity: 0.7;
  transition: opacity 0.3s ease;
  
  &:hover {
    opacity: 1;
  }
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .login-card {
    padding: 2rem !important;
  }
  
  .login-title {
    font-size: 1.5rem;
  }
}

@media (max-width: 600px) {
  .login-container {
    padding: 0 12px;
  }
  
  .login-card {
    padding: 1.5rem !important;
    border-radius: 12px !important;
  }
  
  .login-title {
    font-size: 1.3rem;
  }
}
</style>